import { Container, Col, Row } from 'reactstrap'

const ContainerCol = ({ children, ...props }) => (
  <Container>
    <Row>
      <Col {...props} className='mx-auto'>
        {children}
      </Col>
    </Row>
  </Container>
)

ContainerCol.defaultProps = {
  xl: 10
}

export default ContainerCol
